var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { t } from 'i18next';
import { getTextKeyForScoreBucket } from '../../utils/scoreUtil';
import '../../components/score';
import { BaseComponent } from '../../utils/BaseComponent';
let Header = class Header extends BaseComponent {
    constructor() {
        super(...arguments);
        this.small = false;
    }
    render() {
        var _a;
        if (!this.summary || this.summary.numberOfReceivedFeedbacks === 0) {
            return html `
        <header class='flex items-center'>
          <trust-score>
          </trust-score>
          ${t('No feeedbacks')}
        </header>
      `;
        }
        const feedbacks = this.href ? html `
      <a
        class='block mt-1/2 detail leading-16 font-normal text-link hover:brightness-75 hover:underline focus:brightness-75 focus:underline'
        href=${this.href}>${t('Read all {{count}} feedbacks', { count: this.summary.numberOfReceivedFeedbacks })}</a>
    ` : html ` <p class='mt-1/2 detail leading-16 font-normal'>${t('{{count}}, feedbacks', { count: this.summary.numberOfReceivedFeedbacks })}
      </p>
    `;
        return html `
      <header class='flex items-center'>
        <trust-score score='${this.summary.overallScore}'></trust-score>
        <div class='inline-block align-middle flex-grow'>
          <p class=${`m-0 inline-block strong ${this.small ? 'caption' : ''}`}>
            ${getTextKeyForScoreBucket((_a = this.summary.overallScore) !== null && _a !== void 0 ? _a : 0)}
          </p>
          ${feedbacks}
        </div>
      </header>
    `;
    }
};
__decorate([
    property()
], Header.prototype, "summary", void 0);
__decorate([
    property()
], Header.prototype, "href", void 0);
__decorate([
    property({ type: Boolean })
], Header.prototype, "small", void 0);
Header = __decorate([
    customElement('trust-summary-header')
], Header);
export { Header };
//# sourceMappingURL=Header.js.map